import { useContext } from 'react';

import { Button, ButtonProps } from '@/design-system';

import { StateContext } from '../../../control/state';

export const RawRenderedToggle = ({
  variant = 'outlined',
}: {
  variant?: ButtonProps['variant'];
}) => {
  const state = useContext(StateContext);
  return (
    <Button variant={variant} color="secondary" onClick={state.toggleViewRaw}>
      {state.viewRaw ? 'View Rendered' : 'View Raw'}
    </Button>
  );
};
